var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTourismRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 127,
    viewBox: "0 0 313 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.7 83.4999L291.09 77.5799C292.22 75.6399 292.87 73.3899 292.87 70.9799C292.87 63.7499 287.01 57.8799 279.77 57.8799C272.54 57.8799 266.67 63.7399 266.67 70.9799C266.67 78.2199 272.53 84.0799 279.77 84.0799C283.1 84.0799 286.15 82.8299 288.46 80.7799L293.7 83.4999Z",
    fill: "#66D9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.41 77.3701C110.22 77.3701 114.93 72.6601 114.93 66.8501C114.93 61.04 110.22 56.3301 104.41 56.3301C98.5996 56.3301 93.8896 61.04 93.8896 66.8501C93.8896 72.6601 98.5996 77.3701 104.41 77.3701Z",
    fill: "#0C8599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.06 75.8701C107.87 75.8701 112.58 71.1601 112.58 65.3501C112.58 59.54 107.87 54.8301 102.06 54.8301C96.25 54.8301 91.54 59.54 91.54 65.3501C91.54 71.1601 96.25 75.8701 102.06 75.8701Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5601 58.9199L102.89 62.1199L107.41 61.1999L105.39 65.3499L107.67 69.3699L103.1 68.7399L99.98 72.1399L99.17 67.5999L94.96 65.6799L99.04 63.5099L99.5601 58.9199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.94 24.0703C285.41 17.7403 280.66 12.2403 274.33 11.7803",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.298 108.988L233.907 112.678L237.597 119.069L243.988 115.379L240.298 108.988Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.567 13.3559L297.131 12.0098L295.785 15.4455L299.22 16.7916L300.567 13.3559Z",
    stroke: "#22B8CF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.48 0.0400391L249.65 8.04004L257 4.76004L250.48 0.0400391Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.61 51.2998L292.92 44.7598L289.6 52.0898L297.61 51.2998Z",
    stroke: "#22B8CF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.05 30.8196C270.8 30.6896 270.59 30.4696 270.5 30.1796C270.31 29.5996 270.62 28.9796 271.2 28.7896L273.92 27.8996C274.5 27.7096 275.12 28.0196 275.31 28.5996C275.5 29.1796 275.19 29.7996 274.61 29.9896L271.89 30.8796C271.6 30.9796 271.3 30.9496 271.05 30.8196Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.67 44.8104C304.819 44.8104 305.75 43.8791 305.75 42.7304C305.75 41.5816 304.819 40.6504 303.67 40.6504C302.521 40.6504 301.59 41.5816 301.59 42.7304C301.59 43.8791 302.521 44.8104 303.67 44.8104Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.84 70.4501C256.37 70.4501 257.61 69.21 257.61 67.6802C257.61 66.1503 256.37 64.9102 254.84 64.9102C253.311 64.9102 252.07 66.1503 252.07 67.6802C252.07 69.21 253.311 70.4501 254.84 70.4501Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.81 118.65C267.566 118.65 268.18 118.037 268.18 117.28C268.18 116.524 267.566 115.91 266.81 115.91C266.053 115.91 265.439 116.524 265.439 117.28C265.439 118.037 266.053 118.65 266.81 118.65Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.9 8.74C141.657 8.74 142.27 8.12663 142.27 7.37C142.27 6.61337 141.657 6 140.9 6C140.144 6 139.53 6.61337 139.53 7.37C139.53 8.12663 140.144 8.74 140.9 8.74Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8701 11.2197L78.8102 21.0597",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4199 9.25977L86.2899 21.1698",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.72 111.95L272.3 102.93",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.84 99.6203L272.91 96.8203",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.5 60.5497L291.23 58.1797",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.71 109.19L143.97 94.9297",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.28 43.6599C252.328 43.6599 256.42 39.5678 256.42 34.5199C256.42 29.472 252.328 25.3799 247.28 25.3799C242.232 25.3799 238.14 29.472 238.14 34.5199C238.14 39.5678 242.232 43.6599 247.28 43.6599Z",
    fill: "#0C8599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.209 42.4499C253.257 42.4499 257.349 38.3578 257.349 33.3099C257.349 28.262 253.257 24.1699 248.209 24.1699C243.161 24.1699 239.069 28.262 239.069 33.3099C239.069 38.3578 243.161 42.4499 248.209 42.4499Z",
    fill: "#66D9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.16 34.0397C252.79 36.9797 245.64 36.7897 245.64 36.7897C245.64 36.7897 243.61 30.1297 246.29 28.8097C249.54 27.2197 249.72 31.4196 249.72 31.4196C249.72 31.4196 253.59 30.6297 253.16 34.0397Z",
    fill: "#15AABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.63 29.6201C240.5 32.4101 241.04 36.3901 243.83 38.5201",
    stroke: "white",
    strokeWidth: 0.82,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.04 2.01953L293.6 6.76953",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5605 131.93L68.2606 78.7001C68.3106 78.6401 68.3606 78.5701 68.4106 78.5101C70.0906 76.7401 72.9706 76.8501 74.5005 78.7801L119.001 133.57",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.360352 135.59L42.0403 71.7597C44.3203 68.4497 49.1604 68.3697 51.5604 71.5497C51.6304 71.6497 51.6904 71.7497 51.7504 71.8497L86.2804 136",
    fill: "#C5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.34 39.3C58.35 39.13 58.3701 38.96 58.3701 38.79C58.3701 32.83 53.5401 28 47.5801 28C41.6201 28 36.79 32.83 36.79 38.79C36.79 38.96 36.8101 39.13 36.8201 39.3H36.79L36.8201 39.36C36.5301 45.46 47.5801 62.87 47.5801 62.87C47.5801 62.87 58.34 43.4 58.34 39.36L58.3701 39.3H58.34Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5797 45.4601C51.5506 45.4601 54.7697 42.241 54.7697 38.2701C54.7697 34.2991 51.5506 31.0801 47.5797 31.0801C43.6087 31.0801 40.3896 34.2991 40.3896 38.2701C40.3896 42.241 43.6087 45.4601 47.5797 45.4601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.311 43.7L289.661 33.04",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.21 134L184.46 128.91L184.71 134H206.28C209.4 101.24 204.22 98.9804 204.22 98.9804L169.28 96.4004L158.65 134H182.21Z",
    fill: "#0C8599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.63 67.4799L206.931 104.84C206.931 104.84 182.82 114.79 164.19 106.84L170.75 80.5999L165.83 58.4599C164.45 45.1499 167.801 40.1299 178.891 39.2899L183.031 38.9799C194.301 38.1199 197.61 53.9299 198.63 67.4799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.75 85.5201L176.49 66.6602L196.99 69.1202C196.99 69.1202 190.23 77.2602 187.97 78.9602C181.41 83.8802 170.75 85.5201 170.75 85.5201Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.031 85.3302C196.031 85.3302 182.24 92.9002 169.94 84.7002",
    stroke: "#22B8CF",
    strokeWidth: 4.9201,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.93 35.01C141.89 33.07 126.77 24.9201 126.38 24.4901C125.14 23.1401 124.55 21.5601 123.9 21.7901C121.94 22.4701 120.86 26.0701 120.86 26.0701C120.86 26.0701 143.08 49.2201 147.46 43.7801C149.39 41.3901 148.08 37.03 144.93 35.01Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.001 24.3499C118.911 26.2199 114.481 26.4199 112.661 26.2099C112.201 26.1599 112.011 25.5799 112.371 25.2799C113.041 24.7299 114.391 24.3699 115.361 24.1699C115.951 24.0499 119.161 20.9599 119.001 24.3499Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.63 21.5599C115.33 22.9099 110.5 19.5399 109.27 18.1899C108.96 17.8499 109.2 17.2899 109.66 17.2999C110.53 17.3299 111.78 17.9399 112.65 18.4299C113.17 18.7199 118.98 19.1099 116.63 21.5599Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.351 20.7402L117.911 18.6302C118.661 18.3002 119.751 17.9702 120.611 18.1102C120.961 18.1702 128.111 25.6602 128.111 25.6602C128.111 25.6602 123.311 26.0002 121.551 26.4802C120.831 26.6702 114.891 26.0902 114.891 26.0902C115.461 24.8102 115.291 23.3302 114.461 22.2102L113.351 20.7402Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.79 34.7806C128.49 37.7906 129.67 41.2406 132.67 43.1806C138.83 47.1706 149.07 53.9906 154.66 58.7906C163.39 66.2806 176.6 62.9906 177.64 50.7706C178.5 40.6806 155.31 32.8206 140.44 29.8206C135.93 28.9106 131.41 31.0106 129.79 34.7806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.07 11.7907L161.16 16.2507C160.81 18.0007 161.39 19.8307 162.75 20.9807C164.5 22.4507 167.55 23.8507 172.59 23.0107C177.31 22.2207 179.93 20.2007 181.36 18.3907C182.64 16.7907 182.76 14.5507 181.74 12.7707L179.91 9.57072C177.58 5.49072 172.7 3.50072 168.23 4.97072C167.99 5.05072 167.75 5.13072 167.51 5.23072C164.7 6.32072 162.67 8.82072 162.07 11.7907Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.98 36.9336C188.722 33.0244 192.916 23.3854 189.348 15.4042C185.779 7.42305 175.799 4.12203 167.056 8.0312C158.314 11.9404 154.12 21.5794 157.688 29.5606C161.257 37.5418 171.237 40.8428 179.98 36.9336Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.441 86.5602C156.891 84.4902 156.331 80.8902 158.081 77.7802C161.681 71.3802 167.581 60.5802 170.301 53.7402C174.551 43.0502 187.781 39.8202 194.371 50.1602C199.821 58.7002 182.941 76.4402 171.181 86.0102C167.611 88.9102 162.631 89.1502 159.441 86.5602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.191 45.6199L167.471 30.5699L178.771 24.4199L187.211 40.2699C187.211 40.2699 182.451 48.1899 172.191 45.6199Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.471 30.5801L177.311 45.3401L189.611 37.9601L179.771 30.5801",
    fill: "#1098AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.222 36.7801C180.637 35.993 183.273 30.0657 182.11 23.541C180.947 17.0163 176.425 12.3651 172.01 13.1521C167.595 13.9391 164.959 19.8665 166.122 26.3911C167.285 32.9158 171.807 37.5671 176.222 36.7801Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.24 51.8805C171.24 51.8805 185.5 34.7705 191.25 49.4405",
    stroke: "#22B8CF",
    strokeWidth: 4.9201,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24 104.36L209.35 105.18C200.1 106.72 191.35 99.7699 189.8 89.6599L181.16 33.2499C179.61 23.1399 185.85 13.6899 195.1 12.1499L199.99 11.3299C209.24 9.78987 217.99 16.7399 219.54 26.8499L228.18 83.2599C229.73 93.3699 223.49 102.82 214.24 104.36Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.94 93.5397C209.03 95.2697 199.63 87.3397 197.95 75.8297L193.03 42.2497C191.34 30.7397 198.01 20.0197 207.91 18.2897C217.82 16.5597 227.22 24.4897 228.9 35.9997L233.82 69.5797C235.51 81.0897 228.84 91.8197 218.94 93.5397Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.49 50.8994L209.77 53.5494C204.83 54.4994 200.07 50.8994 199.12 45.4994L196.15 28.5794C195.2 23.1794 198.44 18.0294 203.37 17.0794L217.09 14.4294C222.03 13.4794 226.79 17.0794 227.74 22.4794L230.71 39.3994C231.66 44.7894 228.43 49.9394 223.49 50.8994Z",
    fill: "#66D9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.74 38.8999L206.41 42.0499C202.19 42.8599 198.12 39.7899 197.31 35.1699L195.9 27.1399C195.09 22.5299 197.85 18.1299 202.07 17.3099L218.4 14.1599C222.62 13.3499 226.69 16.4199 227.5 21.0399L228.91 29.0699C229.72 33.6899 226.95 38.0899 222.74 38.8999Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 45.2099C217.57 45.3899 216.67 44.7099 216.49 43.6899L215.2 36.3199L218.57 35.6699L219.86 43.0399C220.04 44.0599 219.43 45.0299 218.5 45.2099Z",
    fill: "#15AABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.3 78.8296L215.29 81.9196C211.66 82.6196 208.16 79.9696 207.46 75.9996L205.98 67.5596C205.28 63.5896 207.66 59.7996 211.29 59.0996L227.3 56.0096C230.93 55.3096 234.44 57.9596 235.13 61.9296L236.61 70.3696C237.31 74.3396 234.93 78.1296 231.3 78.8296Z",
    fill: "#66D9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.82 69.9997L211.82 73.8597C209.29 74.3497 206.85 72.4997 206.37 69.7397L205.6 65.3697C205.12 62.6097 206.77 59.9697 209.3 59.4797L229.3 55.6197C231.83 55.1297 234.27 56.9797 234.75 59.7397L235.52 64.1097C236 66.8697 234.35 69.5097 231.82 69.9997Z",
    fill: "#C5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.349 77.0098C219.589 77.1598 218.859 76.5998 218.719 75.7798L217.729 70.1199L220.469 69.5898L221.459 75.2498C221.599 76.0698 221.109 76.8598 220.349 77.0098Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.83 74.5499C231.07 74.6999 230.34 74.1399 230.2 73.3199L229.21 67.6599L231.95 67.1299L232.94 72.7899C233.08 73.6099 232.59 74.3999 231.83 74.5499Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.891 29.9502L178.931 29.7002C179.071 31.3702 177.811 32.8602 176.141 32.9902C174.491 33.1302 173.011 31.9002 172.851 30.2502L175.891 29.9502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.761 24.6104C176.761 24.6104 178.631 27.9804 176.761 28.1604",
    stroke: "#0C8599",
    strokeWidth: 0.41,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.721 13.0601C172.721 13.0601 165.561 9.87007 163.081 18.2201C160.501 26.8701 167.441 30.7201 167.441 30.7201V25.1201C167.441 25.1201 170.241 23.9701 173.971 19.2501C173.971 19.2501 177.081 23.9601 183.611 19.8701C183.611 19.8701 182.051 18.3901 183.611 16.1501C185.161 13.9201 177.391 6.76007 172.721 13.0601Z",
    fill: "#0C8599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.332 28.0959C169.464 27.6877 170.021 26.3543 169.576 25.1178C169.13 23.8813 167.85 23.2099 166.718 23.6182C165.585 24.0265 165.028 25.3598 165.474 26.5963C165.92 27.8328 167.199 28.5042 168.332 28.0959Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.091 24.53C179.821 23.53 178.801 22.94 177.801 23.21",
    stroke: "#0C8599",
    strokeWidth: 0.41,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.011 22.9799C173.151 22.4199 171.991 22.6599 171.431 23.5199",
    stroke: "#0C8599",
    strokeWidth: 0.41,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.71 59.9107L167.5 55.7107L176.44 53.8607C177.17 53.7107 177.61 52.9607 177.38 52.2507C177.26 51.8707 176.89 51.6107 176.49 51.6207L174.1 51.6707L174.99 50.6507C175.46 50.1107 175.8 49.4807 175.98 48.7907L176.2 47.9607C176.37 47.3407 176.01 46.7007 175.4 46.5007L172.07 45.4507L170.48 44.7207L168.87 45.3407L162.61 53.0307C162.1 53.6607 161.77 54.4207 161.66 55.2307L159.68 64.2907C159.68 64.2907 153.65 82.7607 160.86 84.6107C168.07 86.4607 166.71 59.9107 166.71 59.9107Z",
    fill: "#99E9F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourismRightImage);
export default __webpack_public_path__ + "static/media/tourismRightImage.8d6e7e62e9153e1ba5fe9844adf6b65b.svg";
export { ForwardRef as ReactComponent };